
import React from "react";
import { Box ,Typography} from "@mui/material";
export default function BookingFooter() {
return(
  <Box sx={{ backgroundColor: "primary.main", padding: "10px", textAlign: "center" }}>
<Typography variant="body2" color="white">
Luxin Hotel
</Typography>
</Box>


)
}